// extracted by mini-css-extract-plugin
export default {"wrapper":"YUNWuNUG9xnwEazwTNgt","breadcrumb":"EvbdPu1x6_faUyz6m43o","title":"aJra56ICBc85ySQPyeDm"};